const CreateByUser = (config) => (target, property, descriptor) => {
  if (!descriptor) { // 避免在方法上添加
    // eslint-disable-next-line no-param-reassign
    target.prototype.setUserConfig = function setUserConfig(userInfo) {
      const newConfig = {};
      if (config.getBaseURL) {
        newConfig.baseURL = config.getBaseURL(userInfo.zone);
      }

      if (config.getUserParams) {
        newConfig.params = config.getUserParams(userInfo);
      }

      this.changePublicConfig(newConfig);
    };
  }
};

export default CreateByUser;
